import { getResource } from "../../util/getResourcePermission";
import { getRoles } from "../../util/getRoles";
import config from "../../permission/config.json";

// Client-side only index for the "Settings" category in Global Search — no API call.
// `route` is the path (without companySlug prefix) and `tabKey` must match the real
// TabPane `key` in AttendanceSettings.js / SettingsModule.js so the deep-link (`?tab=`)
// lands on the right tab. `sectionLabel` is shown as the row subtitle so a result like
// "Punch Calculation Mode" tells you which settings page it lives under.
const GENERAL_SETTINGS = "General Settings";
const SYSTEM_SETTINGS = "System Settings";

// Same permission each section's real page is gated behind in newRoutes.js -
// a viewer who can't open the page shouldn't see it suggested by search either.
const SECTION_RESOURCE = {
  [GENERAL_SETTINGS]: config.RESOURCES.ADMIN_REGULARIZATION,
  [SYSTEM_SETTINGS]: config.RESOURCES.SETTINGS,
};

export const SETTINGS_SEARCH_INDEX = [
  { label: "Regularization Limits", route: "/admin-attendance-settings", tabKey: "regularization", sectionLabel: GENERAL_SETTINGS },
  { label: "Lifecycle Settings", route: "/admin-attendance-settings", tabKey: "lifecycle", sectionLabel: GENERAL_SETTINGS },
  { label: "Separation Settings", route: "/admin-attendance-settings", tabKey: "separation", sectionLabel: GENERAL_SETTINGS },
  { label: "On-Duty Regularization", route: "/admin-attendance-settings", tabKey: "onDuty", sectionLabel: GENERAL_SETTINGS },
  { label: "Punch Calculation Mode", route: "/admin-attendance-settings", tabKey: "punch", sectionLabel: GENERAL_SETTINGS },
  { label: "Time Calculation Mode", route: "/admin-attendance-settings", tabKey: "timeCalculationMode", sectionLabel: GENERAL_SETTINGS },
  { label: "Review Forms", route: "/admin-attendance-settings", tabKey: "reviewForms", sectionLabel: GENERAL_SETTINGS },
  { label: "Shift Swap / Change", route: "/admin-attendance-settings", tabKey: "shiftSwap", sectionLabel: GENERAL_SETTINGS },
  { label: "WFH Settings", route: "/admin-attendance-settings", tabKey: "wfh", sectionLabel: GENERAL_SETTINGS },
  { label: "Flexi Leave Settings", route: "/admin-attendance-settings", tabKey: "flexiLeave", sectionLabel: GENERAL_SETTINGS },
  { label: "Overtime", route: "/admin-attendance-settings", tabKey: "overtime", sectionLabel: GENERAL_SETTINGS },
  { label: "Auto Shift", route: "/admin-attendance-settings", tabKey: "autoShift", sectionLabel: GENERAL_SETTINGS },
  { label: "Weekoff Slab Rule", route: "/admin-attendance-settings", tabKey: "weekoffSlab", sectionLabel: GENERAL_SETTINGS },
  { label: "Email Configuration", route: "/admin/settings", tabKey: "email", sectionLabel: SYSTEM_SETTINGS },
  { label: "Biometric Device", route: "/admin/settings", tabKey: "biometric", sectionLabel: SYSTEM_SETTINGS },
  { label: "Security", route: "/admin/settings", tabKey: "security", sectionLabel: SYSTEM_SETTINGS },
  { label: "Date/Time Configurations", route: "/admin/settings", tabKey: "dateFormat", sectionLabel: SYSTEM_SETTINGS },
  { label: "Mira AI", route: "/admin/settings", tabKey: "mira", sectionLabel: SYSTEM_SETTINGS },
];

// Settings pages are always admin configuration, never a "view my own" page
// elsewhere - unlike QUICK_LINKS' Attendance Register/Work Week entries, there's
// no ambiguous shared resource flag here, but the explicit role check is kept
// as the same defense-in-depth belt-and-braces as those.
const SETTINGS_ROLES = ["Admin", "HR"];

export const searchSettingsIndex = (query) => {
  const q = query.trim().toLowerCase();
  if (!q) return [];
  return SETTINGS_SEARCH_INDEX.filter(
    (entry) =>
      entry.label.toLowerCase().includes(q) &&
      getResource(SECTION_RESOURCE[entry.sectionLabel], ["read"]) &&
      getRoles(SETTINGS_ROLES)
  );
};
